/**
 * Web component: Newsletter popup (newsletter-popup)
 * -----------------------------------------------------------------------------
 * Popup with a Klaviyo newsletter signup form.
 *
 */
import './newsletter-popup.scss';

import { vueReady } from '~/core/runners';

/**
 * Create new <newsletter-popup> custom element.
 */
class NewsletterPopup extends HTMLElement {
  /**
   * Custom element constructor.
   * - Always call super first in constructor.
   */
  constructor() {
    super();
    this.$data = {};
  }

  /**
   * Lifecycle hook - component is attached to DOM.
   */
  connectedCallback() {
    const clicks = this.handleClickedLinks();

    if (clicks === 2) {
      cnvs.EventBus.emit('overlay:open', {
        namespace: 'newsletterPopup',
        queue: true,
      });
    } else {
      this.setLinkClickListener();
    }
  }

  /**
   * Get clicked links count from localstorage.
   * @returns {number}
   */
  handleClickedLinks() {
    return Number(localStorage.getItem('esn-popup-clicks')) || 0;
  }

  /**
   * Set link click listener and increment localstorage count.
   */
  setLinkClickListener() {
    document.addEventListener('click', (event) => {
      let target = event.target;

      while (target && target.nodeName !== 'A') {
        target = target.parentNode;
      }

      if (target && target.nodeName === 'A') {
        localStorage.setItem('esn-popup-clicks', this.handleClickedLinks() + 1);
      }
    });
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('newsletter-popup')) {
    return;
  }

  customElements.define('newsletter-popup', NewsletterPopup);
});
